import { ILink } from "../SubCategoryList.types";

const SUB_CATEGORY_ARTICLE_TRANSFORMS = {
  understand: {
    "1911569081": "Understand your bill",
    "1911565221": "High bill explanation",
    "1911568511": "NMI definition",
    "1936979451": "Missing bills",
    "1911571121": "Bill due date",
    "1911570711": "Bill history",
    "1911565451": "Estimated bill",
    "1911555171": "Solar power data",
    "1911562481": "LPG customer number",
    "1911569161": "Bill start date",
    "1911558681": "Payment history",
    "1911560541": "Bill frequency options",
  },
  "payment-extension": {
    "1911571301": "Request payment extension",
    "1911571181": "Length of extension",
    "1911571321": "Unable to extend payment",
    "1911550871": "Pay on time discount",
    "1911565861": "Extension on direct debit",
  },
  making: {
    "1911573251": "Ways to pay",
    "1911571201": "Bill frequency",
    "1911559561": "View my bills",
    "1936979451": "Not getting bills",
    "1911558881": "Solar system payments",
    "1911569161": "First bill",
    "1911571421": "Pending payments",
    "1911565371": "Partial payments",
    "1911571871": "Late payment fees",
    "1911568261": "Recent payment",
    "1971045141": "Error when paying",
  },
  "direct-debit": {
    "1911565681": "Set up direct debit",
    "1911574261": "Cancel direct debit",
    "1911565951": "Update direct debit",
    "1911562631": "Direct debit failed",
    "1911554831": "Incorrectly direct debited",
    "1911553801": "Direct debit bills",
    "1911565861": "Change or delay direct debit date",
    "1911557971": "Manage direct debit",
    "1911556761": "Direct debit process date",
  },
};

export const getArticleId = (route: string) => {
  const lastIndex = route.lastIndexOf("/");
  return lastIndex > -1 ? route.substring(lastIndex + 1) : undefined;
};

export const shouldTransformArticles = (subcategorySlug: string) => {
  return !!SUB_CATEGORY_ARTICLE_TRANSFORMS[subcategorySlug];
};

// Replaces titles, drops articles and alphabetically sorts the articles using the new titles
export const transformArticles = (
  subcategorySlug: string,
  articles: ILink[]
) => {
  const listTransforms = SUB_CATEGORY_ARTICLE_TRANSFORMS[subcategorySlug];

  if (!listTransforms) {
    return articles;
  }

  const mapped = articles.map((article) => {
    return {
      id: getArticleId(article.route),
      ...article,
    };
  });

  const filtered = mapped.filter((article) => {
    return !!listTransforms[article.id];
  });

  const transformed = filtered.map((article) => {
    return {
      title: listTransforms[article.id],
      route: article.route,
    };
  });

  return transformed;
};
